function load_cart() {
  fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = 'cart-drawer';
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.querySelector('.cart-sidebar');
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;
      document.querySelectorAll('.item-remove').forEach(function (cartRemove) {
        var data_line = cartRemove.dataset.line;
        cartRemove.addEventListener('click', (evt) => removeItem(data_line));
      });
      document.querySelectorAll('.header-cart').forEach(function (cartButton) {
        cartButton.addEventListener('click', function (e) {
          document.querySelector('body').classList.add('open-drawer');
          document.querySelector('body').classList.remove('open-menu', 'open-search', 'open-sort', 'open-filter');
        });
      });
      document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function (cartButton) {
        cartButton.addEventListener('click', function (e) {
          document.querySelector('body').classList.remove('open-drawer', 'open-menu', 'open-search', 'open-sort', 'open-filter', 'open-search-drawer', 'open-filter-drawer');
        });
      });

      document.querySelectorAll('.item-row').forEach(function (itemRow) {
        const minusBtn = itemRow.querySelector('.qty-minus');
        const plusBtn = itemRow.querySelector('.qty-plus');
        const qtyInput = itemRow.querySelector('.qty-input');
        const removeBtn = itemRow.querySelector('.item-remove');

        if (!qtyInput || !removeBtn) return;

        const line = parseInt(removeBtn.dataset.line);

        if (plusBtn) {
          plusBtn.addEventListener('click', function () {
            const currentQty = parseInt(qtyInput.value, 10) || 1;
            updateCartItemQuantity(line, currentQty + 1);
          });
        }

        if (minusBtn) {
          minusBtn.addEventListener('click', function () {
            const currentQty = parseInt(qtyInput.value, 10) || 1;

            if (currentQty > 1) {
              updateCartItemQuantity(line, currentQty - 1);
            }
          });
        }
      });

      const url = '/cart.js';
      fetch(url)
        .then((resp) => resp.json())
        .then(function (data) {
          var cart_count = data.item_count;
          if (cart_count > 0) {
            document.querySelector('.cart-count').innerHTML = cart_count;
            document.querySelector('.cart-count').style.display = 'flex';
          } else {
            document.querySelector('.cart-count').innerHTML = '';
            document.querySelector('.cart-count').style.display = 'none';
          }
        })
        .catch(function (error) {
          console.log(error);
        })
    });
}
load_cart();
function removeItem(data_line) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // data_line is 1-indexed for Shopify carts (e.g., line 1 = index 0)
      const itemIndex = parseInt(data_line) - 1;
      const targetItem = cart.items[itemIndex];

      if (!targetItem) return; // safety check

      // Check if this item is part of a bundle
      const bundleId = targetItem.properties && targetItem.properties['_bundle_id'];

      if (bundleId) {
        // If it's a bundle, gather all items with the same _bundle_id
        let updates = {};
        cart.items.forEach(item => {
          if (item.properties && item.properties['_bundle_id'] === bundleId) {
            // Shopify allows updating by key name instead of line index, which is safer for multiple updates
            updates[item.key] = 0;
          }
        });

        // Submit bulk update to remove the entire bundle
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      } else {
        // Normal item, just remove by line
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: data_line, quantity: 0 })
        });
      }
    })
    .then(response => {
      if (response) return response.json();
    })
    .then(data => {
      if (data) load_cart();
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

function updateCartItemQuantity(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    }),
  })
    .then(response => response.json())
    .then(data => {
      load_cart(); // refresh drawer after update
    })
    .catch(error => console.error('Error:', error));
}
